import { render, staticRenderFns } from "./CompleteContractEmployerKyc.vue?vue&type=template&id=619e60ee&scoped=true"
import script from "./CompleteContractEmployerKyc.vue?vue&type=script&lang=js"
export * from "./CompleteContractEmployerKyc.vue?vue&type=script&lang=js"
import style0 from "./CompleteContractEmployerKyc.vue?vue&type=style&index=0&id=619e60ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619e60ee",
  null
  
)

export default component.exports